<template>
    <div>
        <div class="card-body text-center">
            <h4><i class="fas fas fa-ban text-danger"></i>&nbsp;Contract Voided</h4>
        </div>
        <div class="card-body">
            <p class="text-center aboutscroll">
                Admin has voided the contract so the contract is no longer a valid one.
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Void"
    }
</script>

<style scoped>

</style>
